/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=f9dcc026&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"
import style0 from "./ranking.vue?vue&type=style&index=0&id=f9dcc026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dcc026",
  null
  
)

export default component.exports